import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export function authenticationGuard(): CanActivateFn {
  return async () => {
    const authService: AuthService = inject(AuthService);
    const router = inject(Router);

    // Try to initialize auth if not already done
    // This will attempt to restore session from cookie
    const isAuthenticated = await authService.initializeAuth();

    if (!isAuthenticated) {
      return router.createUrlTree(['/login']);
    }

    return true;
  };
}
